import { AuthExpiredError, getValidAccessToken, refreshAccessToken } from './tokenRefreshService';

export { isTokenExpired } from './tokenRefreshService';

function withAuthorization(options, accessToken) {
    return {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': `Bearer ${accessToken}`,
        },
    };
}

export const fetchWithAuth = async (url, customTenatnId, options = {}) => {
    let accessToken;
    try {
        accessToken = await getValidAccessToken();
    } catch (e) {
        if (e instanceof AuthExpiredError) {
            clearTokensAndRedirectToLogin();
            return;
        }
        throw e;
    }

    const response = await fetch(url, withAuthorization(options, accessToken));
    if (response.status !== 401) {
        return response;
    }

    // The token may have been rotated by another tab or expired by the server's
    // clock. Refresh once and retry; a 401 that survives a fresh token is a
    // permission denial, so it goes back to the caller instead of logging out.
    let freshToken;
    try {
        freshToken = (await refreshAccessToken(accessToken)).access_token;
    } catch (e) {
        if (e instanceof AuthExpiredError) {
            clearTokensAndRedirectToLogin();
            return;
        }
        throw e;
    }
    return fetch(url, withAuthorization(options, freshToken));
};

export function clearTokensAndRedirectToLogin() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/login'; // Redirect to login
}
